/* Built In Imports */
import config from '@config';
/* External Imports */
import { Box, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import SingleImage from '@ieo/Components/SingleImage';

/* Configs */
import { ResearchShowsSt } from '@ieo/Common/CompLangConfig';

/* Styles */
/* Services */
import { searchByFieldId } from '@components/Utility/Shared/SharedService';
/**
 *
 * @param {Object} sectionContent
 * @param {string} region
 * @param {string} lang
 * @returns {ReactElement} component
 */
const IeDescriptionV5 = ({ sectionContent, lang }) => {
  return (
    <Box
      w={{ base: '100%', sm: '450px', md: '100%' }}
      px={{ base: '16px', sm: '20px', md: '30px', xl: '0px' }}
      pt={{ base: '40px', md: '51px', lg: '100px' }}
      pb={{ base: '40px', md: '50px', lg: '100px' }}
      mx="auto"
    >
      <Box
        maxW={{
          base: '100%',
          xl: 1050,
          '2xl': '1036px',
        }}
        w="100%"
        mx="auto"
      >
        <Box
          display="flex"
          gap={{ base: '10px', lg: '60px' }}
          alignItems={{ base: 'flex-start', md: 'flex-end' }}
          justifyContent="space-between"
          flexWrap={{ base: 'wrap', md: 'nowrap' }}
          flexDirection={{ base: 'column', md: 'row-reverse' }}
        >
          <Box maxW="460px" position="relative">
            <Box>
              {' '}
              {searchByFieldId(sectionContent, 'ie-heading-v5') && (
                <Text
                  lineHeight="65px"
                  fontFamily="FedraSansStd-medium"
                  fontSize={{ base: '32px', md: '64px' }}
                  color="#3B444B"
                  display={{ base: 'block', md: 'none' }}
                >
                  {searchByFieldId(sectionContent, 'ie-heading-v5').text}
                </Text>
              )}
              <StructuredTextParser
                str={render(sectionContent[3]?.body)}
                fontFamily="FedraSansStd-book"
                className="innerEngineeringText"
                fontSize={{ base: '16px', md: '18px' }}
                lineHeight={{ base: '30px', xl: '27px' }}
                textAlign={lang === 'ar' ? 'right' : 'left'}
                mt={{ base: '10px', lg: '30px' }}
                color="#6D6358"
                display={{ base: 'block', md: 'none' }}
              />
            </Box>
          </Box>
          <Box display={{ base: 'none', md: 'contents' }}>
            <SingleImage w="100%" h="100%" sectionContent={sectionContent[2]} />
          </Box>
          <Box>
            <Box>
              {searchByFieldId(sectionContent, 'ie-heading-v5') && (
                <Text
                  lineHeight="65px"
                  fontFamily="FedraSansStd-medium"
                  fontSize={{ base: '32px', md: '64px' }}
                  color="#3B444B"
                  display={{ base: 'none', md: 'block' }}
                >
                  {searchByFieldId(sectionContent, 'ie-heading-v5').text}
                </Text>
              )}
              <StructuredTextParser
                str={render(sectionContent[4]?.body)}
                fontFamily="FedraSansStd-book"
                className="innerEngineeringText"
                fontSize={{ base: '16px', md: '18px' }}
                lineHeight={{ base: '30px', xl: '27px' }}
                textAlign={lang === 'ar' ? 'right' : 'left'}
                mt={{ base: '10px', lg: '30px' }}
                color="#6D6358"
              />
              <StructuredTextParser
                str={render(sectionContent[1]?.body)}
                fontFamily="FedraSansStd-book"
                className="innerEngineeringText"
                fontSize={{ base: '16px', md: '18px' }}
                lineHeight={{ base: '30px', xl: '27px' }}
                textAlign={lang === 'ar' ? 'right' : 'left'}
                mt={{ base: '10px', lg: '0px' }}
                color="#6D6358"
              />
            </Box>
          </Box>
          <Box display={{ base: 'flex', md: 'none' }}>
            <SingleImage w="100%" h="100%" sectionContent={sectionContent[2]} />
          </Box>
        </Box>
      </Box>

      <style global jsx>
        {`
          .innerEngineeringText p:last-child {
            padding-top: 10px;
          }
          .innerEngineeringText mark {
            color: #282e8f;
            font-family: ${ResearchShowsSt[lang]?.heading?.fontFamily};
            background: none;
          }

          .innerEngineeringText ul {
            list-style-type: none;
            padding-left: 29px;
            padding-top: 10px;
          }
          .innerEngineeringText ul li {
            position: relative;
            padding-left: 10px;
          }
          .innerEngineeringText ul li::before {
            position: absolute;
            content: '';
            left: -30px;
            top: 15px;
            width: 20px;
            height: 16px;
            background: url(${config.imgPath}/d/46272/1706007377-44.png);
          }
          .innerEngineeringText p {
            color: #6d6358;
            font-family: FedraSansStd-book;
            font-weight: normal;
          }
          .innerEngineeringText p strong {
            font-family: FedraSansStd-medium;
            font-weight: normal;
          }
        `}
      </style>
    </Box>
  );
};

export default IeDescriptionV5;
